<template>
    <div class="content">
        <div class="education_list">
            <div class="education_content" v-for="(v,i) in educationArr" :key="i" @click="editInfo(v)">
                <div class="education_content_top">
                    <span class="college">{{v.company_name}}</span>
                    <span class="timer">{{v.start_date}}-{{v.end_date}}</span>
                </div>
                <div class="education_content_bottom">
                    <span>{{v.department_name}}·{{v.position_name}}·{{v.month_salary}}</span>
                    <img class="del" :src="require('@/assets/img/del.png')" alt="" @click.stop="deletion(v)">
                </div>
            </div>
        </div>
        <van-button plain type="danger" @click="add">添加</van-button>
        <van-button type="danger" class="go" @click="next" ref="savebtn">下一步</van-button>
        <load :loading="loading"></load>
    </div>
</template>

<script>
import { getWorkListApi,getProjectListApi,editWorkExpApi } from '@/api/interview'
import Load from "@/components/Loading"
    export default {
        data(){
            return {
                educationArr:[],
                id:sessionStorage.getItem("ID") || 0,
                loading:false,
            }
        },
        methods:{
            // 删除
            deletion(item){
                this.loading = true
                const params = {
                    resume_id: this.id,
                    ...item,
                    status: 0
                }
                editWorkExpApi(params).then(res=>{
                    if(res.errNo===0){
                        this.getData()
                    }
                })
            },
            // 添加
            add(){
                this.$router.push({path:"/interviews/work",query:{edit:this.$route.query.edit}})
            },
            // 编辑条目
            editInfo(item){
                var info = JSON.stringify(item)
                this.$router.push({path:"/interviews/work",query:{edit:this.$route.query.edit,id:item.id}})
            },
            // 下一步
            next(){
                getProjectListApi({resume_id:this.id}).then(res=>{
                    if(this.$route.query.edit){
                        this.$router.push({path:"/interviews/resume"})
                    } else if(res.result.length>0){
                        this.$router.push({path:"/interviews/projectlist"})
                    }else {
                        this.$router.push({path:"/interviews/project"})
                    }
                })
            },
            // 获取数据
            async getData(){
                const list = await getWorkListApi({resume_id:this.id})
                this.educationArr = list.result
                this.loading = false
            }
        },
        created(){
            const id = sessionStorage.getItem('ID') || 0
            this.id = id
            if(id){
                this.loading = true
            }
            this.getData()
        },
        mounted() {
            if(this.$route.query.edit){
                this.$refs['savebtn'].innerHTML="保存"
            }
        },
        components: {
            Load
        }
    }
</script>

<style scoped lang="less">
/deep/ .van-button {
    width: 88%;
    margin: 0 auto;
    border-radius: 10px;
}
.content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .go {
        position: fixed;
        bottom: 10%;
    }
}
.education_list {
    width: 90%;
    padding: 75px 37px 0 43px;
    font-size: 27px;
}
.education_content {
    padding-bottom: 54px;
    .education_content_top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 27px;
        .college {
            font-weight: 900;
        }
        .timer {
            color: #a1a1a1;
            font-size: 19px;
        }
    }
    .education_content_bottom {
        display: flex;
        justify-content: space-between;
        .del{
            width: 34px;
            height: 34px;
        }
    }
}
</style>